import React, { ReactNode } from 'react'
import styled from 'styled-components'

type Props = {
  variant?: 'h1' | 'h2' | 'h3' | 'p'
  children: ReactNode
  className?: string
}

export default function Heading({ variant, children, className }: Props) {
  const Container = styled[variant || 'p']`
    align-items: center;
    background: ${({ theme }) => theme.palette.primary.light};
    color: ${({ theme }) => theme.palette.font.light};
    display: flex;
    font-size: 14px;
    font-weight: bold;
    height: 36px;
    justify-content: center;
    @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
      display: none;
    }
  `

  return <Container className={className}>{children}</Container>
}
